// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sidenav {
  height: 100vh;
  position: fixed;
  z-index: 999;
  top: 0;
  left: 0;
  background-color: black;
  padding-top: 60px;
  transition: width 0.3s ease;
  overflow-y: auto;
  overflow-x: hidden;
}
.sidenav.nav-expanded {
  width: 240px;
}
.sidenav.nav-collapsed {
  width: 70px;
}
.sidenav .mobile-header-bar {
  display: block;
  width: 100%;
}
.sidenav .nav-items-wrapper {
  display: flex;
  flex-direction: column;
  width: 100%;
}
.sidenav.smalldevicewrapper {
  width: 100% !important;
  display: flex;
  flex-direction: column;
  padding-left: 6vw;
}
@media all and (min-width: 600px) {
  .sidenav.nav-expanded ~ .wrapper {
    margin-left: 240px !important;
    width: calc(100% - 240px) !important;
    transition: margin-left 0.3s ease, width 0.3s ease;
  }
  .sidenav.nav-collapsed ~ .wrapper {
    margin-left: 70px !important;
    width: calc(100% - 70px) !important;
    transition: margin-left 0.3s ease, width 0.3s ease;
  }
}

.activeSubLink {
  font-weight: bold;
  background: rgba(255, 255, 255, 0.15) !important;
}

.openSpan {
  font-size: 30px;
  color: white;
  position: absolute;
  top: 10px;
  left: 5px;
  cursor: pointer;
  z-index: 1005;
}
.openSpan:hover {
  font-weight: bold;
  color: #3b82f6;
  box-shadow: 0 0 4px #3b82f6;
  text-shadow: 0 0 1px #3b82f6;
}
.openSpan:active {
  color: white;
  font-weight: bold;
}

.linkRoot {
  padding: 18px 14px;
  display: flex;
  align-items: left;
  flex-grow: 0;
  flex-shrink: 0;
  flex-basis: auto;
  color: white;
  font-size: 18px;
  font-weight: 800;
  letter-spacing: 0.01em;
  cursor: pointer;
  transition: background 0.2s, color 0.2s;
}
.linkRoot:hover {
  font-weight: bold;
  color: #3b82f6;
  box-shadow: 0 0 4px #3b82f6;
  text-shadow: 0 0 1px #3b82f6;
}
.linkRoot svg {
  margin-right: 10px;
}

.sidenav.nav-collapsed .linkRoot {
  padding: 18px 0;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-grow: 0;
  flex-shrink: 0;
  flex-basis: auto;
  color: white;
  font-size: 15px;
  cursor: pointer;
}
.sidenav.nav-collapsed .linkRoot:hover {
  font-weight: bold;
  color: rgb(241, 46, 241);
  box-shadow: 0 0 4px rgb(241, 46, 241);
  text-shadow: 0 0 1px rgb(241, 46, 241);
}
.sidenav.nav-collapsed .linkRoot svg {
  margin-right: 0;
}
.sidenav.nav-collapsed .linkSpan, .sidenav.nav-collapsed .subLinks {
  display: none !important;
}

.linkSpan {
  display: inline-block;
  transition: opacity 0.2s ease;
  color: white !important;
}

.linkSpan.hidden {
  opacity: 0;
  pointer-events: none;
  visibility: hidden;
  display: none;
}

.symbol.hidden {
  opacity: 0;
  pointer-events: none;
  visibility: hidden;
}

.subLinks {
  padding-left: 30px;
  display: flex;
  flex-direction: column;
  animation: fadeIn 0.3s ease;
}

.subLink {
  display: flex;
  align-items: center;
  padding: 10px 0;
  color: white !important;
  font-size: 14px;
  text-decoration: none;
  cursor: pointer;
}
.subLink:hover {
  color: #3b82f6 !important;
  text-shadow: 0 0 1px #3b82f6;
}

.subLink .linkSpan::before {
  content: "";
  display: inline-block;
  width: 28px;
  height: 1px;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-4px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@media (max-width: 599px) {
  .sidenav.nav-collapsed ~ .wrapper {
    margin-left: 0 !important;
    width: 100% !important;
    padding-top: 56px !important;
    transition: padding-top 0.25s ease-in-out;
  }
  .sidenav.nav-expanded ~ .wrapper {
    margin-left: 0 !important;
    width: 100% !important;
    padding-top: 480px !important;
    transition: padding-top 0.25s ease-in-out;
  }
  .sidenav {
    width: 100% !important;
    height: auto !important;
    position: fixed;
    top: 0;
    left: 0;
    padding-top: 0;
    overflow: visible;
  }
  .sidenav .mobile-header-bar {
    width: 100%;
    height: 56px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 16px;
    background-color: black;
    border-bottom: 1px solid rgba(255, 255, 255, 0.15);
    box-sizing: border-box;
  }
  .sidenav .mobile-header-bar .mobile-title {
    color: white;
    font-weight: 800;
    font-size: 15px;
    letter-spacing: 0.02em;
    padding-left: 45px;
  }
  .sidenav .openSpan {
    font-size: 26px;
    top: 12px;
    left: 16px;
  }
  .sidenav .nav-items-wrapper {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 8px;
    padding: 12px;
    background-color: black;
    box-sizing: border-box;
    width: 100%;
    border-bottom: 2px solid #3b82f6;
    max-height: calc(100vh - 56px);
    overflow-y: auto;
  }
  .sidenav.nav-collapsed .nav-items-wrapper {
    display: none !important;
  }
  .sidenav .nav-section-node {
    flex-grow: 1;
    flex-shrink: 1;
    flex-basis: calc(50% - 4px);
    min-width: 130px;
    position: relative;
  }
  .sidenav .linkRoot {
    flex-direction: column;
    justify-content: center;
    text-align: center;
    background-color: rgba(255, 255, 255, 0.05);
    border-radius: 8px;
    padding: 12px 6px;
    gap: 6px;
    font-size: 18px;
  }
  .sidenav .linkRoot svg {
    margin-right: 0;
  }
  .sidenav .subLinks {
    position: absolute;
    top: 100%;
    left: 0;
    width: 100%;
    z-index: 1010;
    border-radius: 6px;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.5);
    padding-left: 0;
    margin-top: 4px;
    background-color: #0c0c0c;
    border: 1px solid rgba(255, 255, 255, 0.1);
  }
  .sidenav .subLink {
    justify-content: center;
    padding: 12px;
    font-size: 14px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.05);
  }
  .sidenav .subLink .linkSpan::before {
    display: none;
  }
}
.sidenav {
  height: 100vh;
  position: fixed;
  z-index: 999;
  top: 0;
  left: 0;
  background-color: black;
  padding-top: 60px;
  transition: width 0.3s ease;
  overflow-y: auto;
  overflow-x: hidden;
}
.sidenav.nav-expanded {
  width: 240px;
}
.sidenav.nav-collapsed {
  width: 70px;
}
.sidenav .mobile-header-bar {
  display: block;
  width: 100%;
}
.sidenav .nav-items-wrapper {
  display: flex;
  flex-direction: column;
  width: 100%;
}
.sidenav.smalldevicewrapper {
  width: 100% !important;
  display: flex;
  flex-direction: column;
  padding-left: 6vw;
}
@media all and (min-width: 600px) {
  .aside-2:has(.nav-expanded) {
    width: 240px !important;
    flex-shrink: 0;
    transition: width 0.3s ease;
  }
  .aside-2:has(.nav-collapsed) {
    width: 70px !important;
    flex-shrink: 0;
    transition: width 0.3s ease;
  }
  .aside-2:has(.nav-expanded) ~ .wrapper {
    margin-left: 0px !important;
    width: calc(100% - 240px) !important;
    transition: width 0.3s ease;
  }
  .aside-2:has(.nav-collapsed) ~ .wrapper {
    margin-left: 0px !important;
    width: calc(100% - 70px) !important;
    transition: width 0.3s ease;
  }
}

.activeSubLink {
  font-weight: bold;
  background: rgba(255, 255, 255, 0.15) !important;
}

.openSpan {
  font-size: 30px;
  color: white;
  position: absolute;
  top: 10px;
  left: 5px;
  cursor: pointer;
  z-index: 1005;
}
.openSpan:hover {
  font-weight: bold;
  color: #3b82f6;
  box-shadow: 0 0 4px #3b82f6;
  text-shadow: 0 0 1px #3b82f6;
}
.openSpan:active {
  color: white;
  font-weight: bold;
}

.linkRoot {
  padding: 18px 14px;
  display: flex;
  align-items: left;
  flex-grow: 0;
  flex-shrink: 0;
  flex-basis: auto;
  color: white;
  font-size: 18px;
  font-weight: 800;
  letter-spacing: 0.01em;
  cursor: pointer;
  transition: background 0.2s, color 0.2s;
}
.linkRoot:hover {
  font-weight: bold;
  color: #3b82f6;
  box-shadow: 0 0 4px #3b82f6;
  text-shadow: 0 0 1px #3b82f6;
}
.linkRoot svg {
  margin-right: 10px;
}

.sidenav.nav-collapsed .linkRoot {
  padding: 18px 0;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-grow: 0;
  flex-shrink: 0;
  flex-basis: auto;
  color: white;
  font-size: 15px;
  cursor: pointer;
}
.sidenav.nav-collapsed .linkRoot:hover {
  font-weight: bold;
  color: rgb(241, 46, 241);
  box-shadow: 0 0 4px rgb(241, 46, 241);
  text-shadow: 0 0 1px rgb(241, 46, 241);
}
.sidenav.nav-collapsed .linkRoot svg {
  margin-right: 0;
}
.sidenav.nav-collapsed .linkSpan, .sidenav.nav-collapsed .subLinks {
  display: none !important;
}

.linkSpan {
  display: inline-block;
  transition: opacity 0.2s ease;
  color: white !important;
}

.linkSpan.hidden {
  opacity: 0;
  pointer-events: none;
  visibility: hidden;
  display: none;
}

.symbol.hidden {
  opacity: 0;
  pointer-events: none;
  visibility: hidden;
}

.subLinks {
  padding-left: 30px;
  display: flex;
  flex-direction: column;
  animation: fadeIn 0.3s ease;
}

.subLink {
  display: flex;
  align-items: center;
  padding: 10px 0;
  color: white !important;
  font-size: 14px;
  text-decoration: none;
  cursor: pointer;
}
.subLink:hover {
  color: #3b82f6 !important;
  text-shadow: 0 0 1px #3b82f6;
}

.subLink .linkSpan::before {
  content: "";
  display: inline-block;
  width: 28px;
  height: 1px;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-4px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@media (max-width: 599px) {
  .aside-2 {
    width: 100% !important;
    height: auto !important;
  }
  .aside-2:has(.nav-collapsed) ~ .wrapper {
    margin-left: 0 !important;
    width: 100% !important;
    padding-top: 56px !important;
    transition: padding-top 0.25s ease-in-out;
  }
  .aside-2:has(.nav-expanded) ~ .wrapper {
    margin-left: 0 !important;
    width: 100% !important;
    padding-top: 480px !important;
    transition: padding-top 0.25s ease-in-out;
  }
  .sidenav {
    width: 100% !important;
    height: auto !important;
    position: fixed;
    top: 0;
    left: 0;
    padding-top: 0;
    overflow: visible;
  }
  .sidenav .mobile-header-bar {
    width: 100%;
    height: 56px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 16px;
    background-color: black;
    border-bottom: 1px solid rgba(255, 255, 255, 0.15);
    box-sizing: border-box;
  }
  .sidenav .mobile-header-bar .mobile-title {
    color: white;
    font-weight: 800;
    font-size: 15px;
    letter-spacing: 0.02em;
    padding-left: 45px;
  }
  .sidenav .openSpan {
    font-size: 26px;
    top: 12px;
    left: 16px;
  }
  .sidenav .nav-items-wrapper {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 8px;
    padding: 12px;
    background-color: black;
    box-sizing: border-box;
    width: 100%;
    border-bottom: 2px solid #3b82f6;
    max-height: calc(100vh - 56px);
    overflow-y: auto;
  }
  .sidenav.nav-collapsed .nav-items-wrapper {
    display: none !important;
  }
  .sidenav .nav-section-node {
    flex-grow: 1;
    flex-shrink: 1;
    flex-basis: calc(50% - 4px);
    min-width: 130px;
    position: relative;
  }
  .sidenav .linkRoot {
    flex-direction: column;
    justify-content: center;
    text-align: center;
    background-color: rgba(255, 255, 255, 0.05);
    border-radius: 8px;
    padding: 12px 6px;
    gap: 6px;
    font-size: 18px;
  }
  .sidenav .linkRoot svg {
    margin-right: 0;
  }
  .sidenav .subLinks {
    position: absolute;
    top: 100%;
    left: 0;
    width: 100%;
    z-index: 1010;
    border-radius: 6px;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.5);
    padding-left: 0;
    margin-top: 4px;
    background-color: #0c0c0c;
    border: 1px solid rgba(255, 255, 255, 0.1);
  }
  .sidenav .subLink {
    justify-content: center;
    padding: 12px;
    font-size: 14px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.05);
  }
  .sidenav .subLink .linkSpan::before {
    display: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/navbar/navbar.scss"],"names":[],"mappings":"AAGA;EACE,aAAA;EACA,eAAA;EACA,YAAA;EACA,MAAA;EACA,OAAA;EACA,uBAAA;EACA,iBAAA;EACA,2BAAA;EACA,gBAAA;EACA,kBAAA;AAFF;AAKE;EAAiB,YAAA;AAFnB;AAGE;EAAkB,WAAA;AAApB;AAGE;EACE,cAAA;EACA,WAAA;AADJ;AAIE;EACE,aAAA;EACA,sBAAA;EACA,WAAA;AAFJ;AAKE;EACE,sBAAA;EACA,aAAA;EACA,sBAAA;EACA,iBAAA;AAHJ;AASI;EACE;IACE,6BAAA;IACA,oCAAA;IACA,kDAAA;EAPN;EASI;IACE,4BAAA;IACA,mCAAA;IACA,kDAAA;EAPN;AACF;;AAYA;EACE,iBAAA;EACA,gDAAA;AATF;;AAYA;EACE,eAAA;EACA,YAAA;EACA,kBAAA;EACA,SAAA;EACA,SAAA;EACA,eAAA;EACA,aAAA;AATF;AAWE;EACE,iBAAA;EACA,cAAA;EACA,2BAAA;EACA,4BAAA;AATJ;AAYE;EACE,YAAA;EACA,iBAAA;AAVJ;;AAcA;EACE,kBAAA;EACA,aAAA;EACA,iBAAA;EACA,YAAA;EACA,cAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,eAAA;EACA,uCAAA;AAXF;AAaE;EACE,iBAAA;EACA,cAAA;EACA,2BAAA;EACA,4BAAA;AAXJ;AAcE;EACE,kBAAA;AAZJ;;AAkBE;EACE,eAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,cAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;EACA,eAAA;AAfJ;AAiBI;EACE,iBAAA;EACA,wBAAA;EACA,qCAAA;EACA,sCAAA;AAfN;AAkBI;EACE,eAAA;AAhBN;AAoBE;EACE,wBAAA;AAlBJ;;AAsBA;EACE,qBAAA;EACA,6BAAA;EACA,uBAAA;AAnBF;;AAsBA;EACE,UAAA;EACA,oBAAA;EACA,kBAAA;EACA,aAAA;AAnBF;;AAsBA;EACE,UAAA;EACA,oBAAA;EACA,kBAAA;AAnBF;;AAsBA;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,2BAAA;AAnBF;;AAsBA;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,uBAAA;EACA,eAAA;EACA,qBAAA;EACA,eAAA;AAnBF;AAqBE;EACE,yBAAA;EACA,4BAAA;AAnBJ;;AAuBA;EACE,WAAA;EACA,qBAAA;EACA,WAAA;EACA,WAAA;AApBF;;AAuBA;EACE;IACE,UAAA;IACA,2BAAA;EApBF;EAsBA;IACE,UAAA;IACA,wBAAA;EApBF;AACF;AA0BA;EAGI;IACE,yBAAA;IACA,sBAAA;IACA,4BAAA;IACA,yCAAA;EA1BJ;EA4BE;IACE,yBAAA;IACA,sBAAA;IACA,6BAAA;IACA,yCAAA;EA1BJ;EA8BA;IACE,sBAAA;IACA,uBAAA;IACA,eAAA;IACA,MAAA;IACA,OAAA;IACA,cAAA;IACA,iBAAA;EA5BF;EA8BE;IACE,WAAA;IACA,YAAA;IACA,aAAA;IACA,8BAAA;IACA,mBAAA;IACA,eAAA;IACA,uBAAA;IACA,kDAAA;IACA,sBAAA;EA5BJ;EA8BI;IACE,YAAA;IACA,gBAAA;IACA,eAAA;IACA,sBAAA;IACA,kBAAA;EA5BN;EAgCE;IACE,eAAA;IACA,SAAA;IACA,UAAA;EA9BJ;EAkCE;IACE,aAAA;IACA,mBAAA;IACA,eAAA;IACA,QAAA;IACA,aAAA;IACA,uBAAA;IACA,sBAAA;IACA,WAAA;IACA,gCAAA;IACA,8BAAA;IACA,gBAAA;EAhCJ;EAoCI;IACE,wBAAA;EAlCN;EAsCE;IACE,YAAA;IAAA,cAAA;IAAA,2BAAA;IACA,gBAAA;IACA,kBAAA;EApCJ;EAuCE;IACE,sBAAA;IACA,uBAAA;IACA,kBAAA;IACA,2CAAA;IACA,kBAAA;IACA,iBAAA;IACA,QAAA;IACA,eAAA;EArCJ;EAuCI;IACE,eAAA;EArCN;EA0CE;IACE,kBAAA;IACA,SAAA;IACA,OAAA;IACA,WAAA;IACA,aAAA;IACA,kBAAA;IACA,yCAAA;IACA,eAAA;IACA,eAAA;IACA,yBAAA;IACA,0CAAA;EAxCJ;EA2CE;IACE,uBAAA;IACA,aAAA;IACA,eAAA;IACA,kDAAA;EAzCJ;EA2CI;IACE,aAAA;EAzCN;AACF;AA+CA;EACE,aAAA;EACA,eAAA;EACA,YAAA;EACA,MAAA;EACA,OAAA;EACA,uBAAA;EACA,iBAAA;EACA,2BAAA;EACA,gBAAA;EACA,kBAAA;AA7CF;AAgDE;EAAiB,YAAA;AA7CnB;AA8CE;EAAkB,WAAA;AA3CpB;AA8CE;EACE,cAAA;EACA,WAAA;AA5CJ;AA+CE;EACE,aAAA;EACA,sBAAA;EACA,WAAA;AA7CJ;AAgDE;EACE,sBAAA;EACA,aAAA;EACA,sBAAA;EACA,iBAAA;AA9CJ;AAqDI;EACE;IACE,uBAAA;IACA,cAAA;IACA,2BAAA;EAnDN;EAqDI;IACE,sBAAA;IACA,cAAA;IACA,2BAAA;EAnDN;EAqDI;IACE,2BAAA;IACA,oCAAA;IACA,2BAAA;EAnDN;EAqDI;IACE,2BAAA;IACA,mCAAA;IACA,2BAAA;EAnDN;AACF;;AAwDA;EACE,iBAAA;EACA,gDAAA;AArDF;;AAwDA;EACE,eAAA;EACA,YAAA;EACA,kBAAA;EACA,SAAA;EACA,SAAA;EACA,eAAA;EACA,aAAA;AArDF;AAuDE;EACE,iBAAA;EACA,cAAA;EACA,2BAAA;EACA,4BAAA;AArDJ;AAwDE;EACE,YAAA;EACA,iBAAA;AAtDJ;;AA0DA;EACE,kBAAA;EACA,aAAA;EACA,iBAAA;EACA,YAAA;EACA,cAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,eAAA;EACA,uCAAA;AAvDF;AAyDE;EACE,iBAAA;EACA,cAAA;EACA,2BAAA;EACA,4BAAA;AAvDJ;AA0DE;EACE,kBAAA;AAxDJ;;AA8DE;EACE,eAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,cAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;EACA,eAAA;AA3DJ;AA6DI;EACE,iBAAA;EACA,wBAAA;EACA,qCAAA;EACA,sCAAA;AA3DN;AA8DI;EACE,eAAA;AA5DN;AAgEE;EACE,wBAAA;AA9DJ;;AAkEA;EACE,qBAAA;EACA,6BAAA;EACA,uBAAA;AA/DF;;AAkEA;EACE,UAAA;EACA,oBAAA;EACA,kBAAA;EACA,aAAA;AA/DF;;AAkEA;EACE,UAAA;EACA,oBAAA;EACA,kBAAA;AA/DF;;AAkEA;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,2BAAA;AA/DF;;AAkEA;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,uBAAA;EACA,eAAA;EACA,qBAAA;EACA,eAAA;AA/DF;AAiEE;EACE,yBAAA;EACA,4BAAA;AA/DJ;;AAmEA;EACE,WAAA;EACA,qBAAA;EACA,WAAA;EACA,WAAA;AAhEF;;AAmEA;EACE;IACE,UAAA;IACA,2BAAA;EAhEF;EAkEA;IACE,UAAA;IACA,wBAAA;EAhEF;AACF;AAsEA;EAGI;IACE,sBAAA;IACA,uBAAA;EAtEJ;EAwEE;IACE,yBAAA;IACA,sBAAA;IACA,4BAAA;IACA,yCAAA;EAtEJ;EAwEE;IACE,yBAAA;IACA,sBAAA;IACA,6BAAA;IACA,yCAAA;EAtEJ;EA0EA;IACE,sBAAA;IACA,uBAAA;IACA,eAAA;IACA,MAAA;IACA,OAAA;IACA,cAAA;IACA,iBAAA;EAxEF;EA0EE;IACE,WAAA;IACA,YAAA;IACA,aAAA;IACA,8BAAA;IACA,mBAAA;IACA,eAAA;IACA,uBAAA;IACA,kDAAA;IACA,sBAAA;EAxEJ;EA0EI;IACE,YAAA;IACA,gBAAA;IACA,eAAA;IACA,sBAAA;IACA,kBAAA;EAxEN;EA4EE;IACE,eAAA;IACA,SAAA;IACA,UAAA;EA1EJ;EA8EE;IACE,aAAA;IACA,mBAAA;IACA,eAAA;IACA,QAAA;IACA,aAAA;IACA,uBAAA;IACA,sBAAA;IACA,WAAA;IACA,gCAAA;IACA,8BAAA;IACA,gBAAA;EA5EJ;EAgFI;IACE,wBAAA;EA9EN;EAkFE;IACE,YAAA;IAAA,cAAA;IAAA,2BAAA;IACA,gBAAA;IACA,kBAAA;EAhFJ;EAmFE;IACE,sBAAA;IACA,uBAAA;IACA,kBAAA;IACA,2CAAA;IACA,kBAAA;IACA,iBAAA;IACA,QAAA;IACA,eAAA;EAjFJ;EAmFI;IACE,eAAA;EAjFN;EAsFE;IACE,kBAAA;IACA,SAAA;IACA,OAAA;IACA,WAAA;IACA,aAAA;IACA,kBAAA;IACA,yCAAA;IACA,eAAA;IACA,eAAA;IACA,yBAAA;IACA,0CAAA;EApFJ;EAuFE;IACE,uBAAA;IACA,aAAA;IACA,eAAA;IACA,kDAAA;EArFJ;EAuFI;IACE,aAAA;EArFN;AACF","sourcesContent":["// ==========================================\n// 💻 CORE DESKTOP LAYOUT (PRESERVED OLD STYLES)\n// ==========================================\n.sidenav {\n  height: 100vh; \n  position: fixed; \n  z-index: 999;\n  top: 0;\n  left: 0;\n  background-color: black;\n  padding-top: 60px;\n  transition: width 0.3s ease;\n  overflow-y: auto;\n  overflow-x: hidden;\n\n  // Handles smooth JS desktop sizing states cleanly via classes \n  &.nav-expanded { width: 240px; }\n  &.nav-collapsed { width: 70px; } \n\n  // Clean layout controller block for mobile header strip inclusion\n  .mobile-header-bar {\n    display: block;\n    width: 100%;\n  }\n\n  .nav-items-wrapper {\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n  }\n\n  &.smalldevicewrapper {\n    width: 100% !important;\n    display: flex;\n    flex-direction: column;\n    padding-left: 6vw;\n  }\n\n  // 🌟 FIX: PUSHES WRAPPER TO THE RIGHT ON DESKTOP\n  // Purely handles layout displacement right from inside this selector\n  @at-root {\n    @media all and (min-width: 600px) {\n      .sidenav.nav-expanded ~ .wrapper {\n        margin-left: 240px !important;\n        width: calc(100% - 240px) !important;\n        transition: margin-left 0.3s ease, width 0.3s ease;\n      }\n      .sidenav.nav-collapsed ~ .wrapper {\n        margin-left: 70px !important;\n        width: calc(100% - 70px) !important;\n        transition: margin-left 0.3s ease, width 0.3s ease;\n      }\n    }\n  }\n}\n\n.activeSubLink {\n  font-weight: bold;\n  background: rgba(255, 255, 255, 0.15) !important;\n}\n\n.openSpan {\n  font-size: 30px;\n  color: white;\n  position: absolute;\n  top: 10px;\n  left: 5px;\n  cursor: pointer;\n  z-index: 1005;\n\n  &:hover {\n    font-weight: bold;\n    color: #3b82f6;\n    box-shadow: 0 0 4px #3b82f6;\n    text-shadow: 0 0 1px #3b82f6;\n  }\n\n  &:active {\n    color: white;\n    font-weight: bold;\n  }\n}\n\n.linkRoot {\n  padding: 18px 14px;\n  display: flex;\n  align-items: left;\n  flex-grow: 0;\n  flex-shrink: 0;\n  flex-basis: auto;\n  color: white;\n  font-size: 18px;\n  font-weight: 800;\n  letter-spacing: 0.01em;\n  cursor: pointer;\n  transition: background 0.2s, color 0.2s;\n\n  &:hover {\n    font-weight: bold;\n    color: #3b82f6;\n    box-shadow: 0 0 4px #3b82f6;\n    text-shadow: 0 0 1px #3b82f6;\n  }\n\n  svg {\n    margin-right: 10px;\n  }\n}\n\n// Keep old styling block target constraints intact when collapsed on desktop\n.sidenav.nav-collapsed {\n  .linkRoot {\n    padding: 18px 0;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex-grow: 0;\n    flex-shrink: 0;\n    flex-basis: auto;\n    color: white;\n    font-size: 15px;\n    cursor: pointer;\n\n    &:hover {\n      font-weight: bold;\n      color: rgb(241, 46, 241);\n      box-shadow: 0 0 4px rgb(241, 46, 241);\n      text-shadow: 0 0 1px rgb(241, 46, 241);\n    }\n\n    svg {\n      margin-right: 0;\n    }\n  }\n\n  .linkSpan, .subLinks {\n    display: none !important;\n  }\n}\n\n.linkSpan {\n  display: inline-block;\n  transition: opacity 0.2s ease;\n  color: white !important; \n}\n\n.linkSpan.hidden {\n  opacity: 0;\n  pointer-events: none;\n  visibility: hidden;\n  display: none;\n}\n\n.symbol.hidden {\n  opacity: 0;\n  pointer-events: none;\n  visibility: hidden;\n}\n\n.subLinks {\n  padding-left: 30px;\n  display: flex;\n  flex-direction: column;\n  animation: fadeIn 0.3s ease;\n}\n\n.subLink {\n  display: flex;\n  align-items: center;\n  padding: 10px 0;\n  color: white !important; \n  font-size: 14px; \n  text-decoration: none;\n  cursor: pointer;\n\n  &:hover {\n    color: #3b82f6 !important;\n    text-shadow: 0 0 1px #3b82f6;\n  }\n}\n\n.subLink .linkSpan::before {\n  content: \"\";\n  display: inline-block;\n  width: 28px; \n  height: 1px;\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(-4px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n// ==========================================\n// 📱 NEW MOBILE RESPONSIVE REBOOT OVERRIDE (< 599px)\n// ==========================================\n@media (max-width: 599px) {\n  // 🌟 FIX: PUSHES WRAPPER CONTENT DOWN PAST OPEN MENU ON MOBILE\n  @at-root {\n    .sidenav.nav-collapsed ~ .wrapper {\n      margin-left: 0 !important;\n      width: 100% !important;\n      padding-top: 56px !important; \n      transition: padding-top 0.25s ease-in-out;\n    }\n    .sidenav.nav-expanded ~ .wrapper {\n      margin-left: 0 !important;\n      width: 100% !important;\n      padding-top: 480px !important; // Clean clear offset space underneath active tile height\n      transition: padding-top 0.25s ease-in-out;\n    }\n  }\n\n  .sidenav {\n    width: 100% !important; \n    height: auto !important;\n    position: fixed;\n    top: 0;\n    left: 0;\n    padding-top: 0; \n    overflow: visible;\n\n    .mobile-header-bar {\n      width: 100%;\n      height: 56px;\n      display: flex;\n      justify-content: space-between;\n      align-items: center;\n      padding: 0 16px;\n      background-color: black;\n      border-bottom: 1px solid rgba(255, 255, 255, 0.15);\n      box-sizing: border-box;\n\n      .mobile-title {\n        color: white;\n        font-weight: 800;\n        font-size: 15px;\n        letter-spacing: 0.02em;\n        padding-left: 45px; \n      }\n    }\n\n    .openSpan {\n      font-size: 26px;\n      top: 12px;\n      left: 16px;\n    }\n\n    // THE HORIZONTAL EXPANSION GRID LAYOUT ENGINE\n    .nav-items-wrapper {\n      display: flex;\n      flex-direction: row; \n      flex-wrap: wrap;     \n      gap: 8px;\n      padding: 12px;\n      background-color: black;\n      box-sizing: border-box;\n      width: 100%;\n      border-bottom: 2px solid #3b82f6;\n      max-height: calc(100vh - 56px);\n      overflow-y: auto;\n    }\n\n    &.nav-collapsed {\n      .nav-items-wrapper {\n        display: none !important; \n      }\n    }\n\n    .nav-section-node {\n      flex: 1 1 calc(50% - 4px); \n      min-width: 130px;\n      position: relative;\n    }\n\n    .linkRoot {\n      flex-direction: column; \n      justify-content: center;\n      text-align: center;\n      background-color: rgba(255, 255, 255, 0.05);\n      border-radius: 8px;\n      padding: 12px 6px;\n      gap: 6px;\n      font-size: 18px; \n\n      svg {\n        margin-right: 0;\n      }\n    }\n\n    // Dropdown layouts popping down from horizontal tiles\n    .subLinks {\n      position: absolute;\n      top: 100%;\n      left: 0;\n      width: 100%;\n      z-index: 1010;\n      border-radius: 6px;\n      box-shadow: 0 8px 24px rgba(0, 0, 0, 0.5);\n      padding-left: 0;\n      margin-top: 4px;\n      background-color: #0c0c0c;\n      border: 1px solid rgba(255, 255, 255, 0.1);\n    }\n\n    .subLink {\n      justify-content: center;\n      padding: 12px;\n      font-size: 14px; \n      border-bottom: 1px solid rgba(255, 255, 255, 0.05);\n\n      .linkSpan::before {\n        display: none; \n      }\n    }\n  }\n}// ==========================================\n// 💻 CORE DESKTOP LAYOUT (PRESERVED OLD STYLES)\n// ==========================================\n.sidenav {\n  height: 100vh; \n  position: fixed; \n  z-index: 999;\n  top: 0;\n  left: 0;\n  background-color: black;\n  padding-top: 60px;\n  transition: width 0.3s ease;\n  overflow-y: auto;\n  overflow-x: hidden;\n\n  // Handles smooth JS desktop sizing states cleanly via classes \n  &.nav-expanded { width: 240px; }\n  &.nav-collapsed { width: 70px; } \n\n  // Clean layout controller block for mobile header strip inclusion\n  .mobile-header-bar {\n    display: block;\n    width: 100%;\n  }\n\n  .nav-items-wrapper {\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n  }\n\n  &.smalldevicewrapper {\n    width: 100% !important;\n    display: flex;\n    flex-direction: column;\n    padding-left: 6vw;\n  }\n\n  // 🌟 FIXED FOR DESKTOP: RELATIONAL PARENT SELECTOR OVERRIDE\n  // Since .sidenav is inside .aside-2, we look at the parent .aside-2 \n  // and dynamically push the adjacent .wrapper layout block over.\n  @at-root {\n    @media all and (min-width: 600px) {\n      .aside-2:has(.nav-expanded) {\n        width: 240px !important;\n        flex-shrink: 0;\n        transition: width 0.3s ease;\n      }\n      .aside-2:has(.nav-collapsed) {\n        width: 70px !important;\n        flex-shrink: 0;\n        transition: width 0.3s ease;\n      }\n      .aside-2:has(.nav-expanded) ~ .wrapper {\n        margin-left: 0px !important; // Pushed naturally by flex box widths now\n        width: calc(100% - 240px) !important;\n        transition: width 0.3s ease;\n      }\n      .aside-2:has(.nav-collapsed) ~ .wrapper {\n        margin-left: 0px !important; \n        width: calc(100% - 70px) !important;\n        transition: width 0.3s ease;\n      }\n    }\n  }\n}\n\n.activeSubLink {\n  font-weight: bold;\n  background: rgba(255, 255, 255, 0.15) !important;\n}\n\n.openSpan {\n  font-size: 30px;\n  color: white;\n  position: absolute;\n  top: 10px;\n  left: 5px;\n  cursor: pointer;\n  z-index: 1005;\n\n  &:hover {\n    font-weight: bold;\n    color: #3b82f6;\n    box-shadow: 0 0 4px #3b82f6;\n    text-shadow: 0 0 1px #3b82f6;\n  }\n\n  &:active {\n    color: white;\n    font-weight: bold;\n  }\n}\n\n.linkRoot {\n  padding: 18px 14px;\n  display: flex;\n  align-items: left;\n  flex-grow: 0;\n  flex-shrink: 0;\n  flex-basis: auto;\n  color: white;\n  font-size: 18px;\n  font-weight: 800;\n  letter-spacing: 0.01em;\n  cursor: pointer;\n  transition: background 0.2s, color 0.2s;\n\n  &:hover {\n    font-weight: bold;\n    color: #3b82f6;\n    box-shadow: 0 0 4px #3b82f6;\n    text-shadow: 0 0 1px #3b82f6;\n  }\n\n  svg {\n    margin-right: 10px;\n  }\n}\n\n// Keep old styling block target constraints intact when collapsed on desktop\n.sidenav.nav-collapsed {\n  .linkRoot {\n    padding: 18px 0;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex-grow: 0;\n    flex-shrink: 0;\n    flex-basis: auto;\n    color: white;\n    font-size: 15px;\n    cursor: pointer;\n\n    &:hover {\n      font-weight: bold;\n      color: rgb(241, 46, 241);\n      box-shadow: 0 0 4px rgb(241, 46, 241);\n      text-shadow: 0 0 1px rgb(241, 46, 241);\n    }\n\n    svg {\n      margin-right: 0;\n    }\n  }\n\n  .linkSpan, .subLinks {\n    display: none !important;\n  }\n}\n\n.linkSpan {\n  display: inline-block;\n  transition: opacity 0.2s ease;\n  color: white !important; \n}\n\n.linkSpan.hidden {\n  opacity: 0;\n  pointer-events: none;\n  visibility: hidden;\n  display: none;\n}\n\n.symbol.hidden {\n  opacity: 0;\n  pointer-events: none;\n  visibility: hidden;\n}\n\n.subLinks {\n  padding-left: 30px;\n  display: flex;\n  flex-direction: column;\n  animation: fadeIn 0.3s ease;\n}\n\n.subLink {\n  display: flex;\n  align-items: center;\n  padding: 10px 0;\n  color: white !important; \n  font-size: 14px; \n  text-decoration: none;\n  cursor: pointer;\n\n  &:hover {\n    color: #3b82f6 !important;\n    text-shadow: 0 0 1px #3b82f6;\n  }\n}\n\n.subLink .linkSpan::before {\n  content: \"\";\n  display: inline-block;\n  width: 28px; \n  height: 1px;\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(-4px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n// ==========================================\n// 📱 NEW MOBILE RESPONSIVE REBOOT OVERRIDE (< 599px)\n// ==========================================\n@media (max-width: 599px) {\n  // PUSHES WRAPPER CONTENT DOWN PAST OPEN MENU ON MOBILE Safely\n  @at-root {\n    .aside-2 {\n      width: 100% !important;\n      height: auto !important;\n    }\n    .aside-2:has(.nav-collapsed) ~ .wrapper {\n      margin-left: 0 !important;\n      width: 100% !important;\n      padding-top: 56px !important; \n      transition: padding-top 0.25s ease-in-out;\n    }\n    .aside-2:has(.nav-expanded) ~ .wrapper {\n      margin-left: 0 !important;\n      width: 100% !important;\n      padding-top: 480px !important; \n      transition: padding-top 0.25s ease-in-out;\n    }\n  }\n\n  .sidenav {\n    width: 100% !important; \n    height: auto !important;\n    position: fixed;\n    top: 0;\n    left: 0;\n    padding-top: 0; \n    overflow: visible;\n\n    .mobile-header-bar {\n      width: 100%;\n      height: 56px;\n      display: flex;\n      justify-content: space-between;\n      align-items: center;\n      padding: 0 16px;\n      background-color: black;\n      border-bottom: 1px solid rgba(255, 255, 255, 0.15);\n      box-sizing: border-box;\n\n      .mobile-title {\n        color: white;\n        font-weight: 800;\n        font-size: 15px;\n        letter-spacing: 0.02em;\n        padding-left: 45px; \n      }\n    }\n\n    .openSpan {\n      font-size: 26px;\n      top: 12px;\n      left: 16px;\n    }\n\n    // THE HORIZONTAL EXPANSION GRID LAYOUT ENGINE\n    .nav-items-wrapper {\n      display: flex;\n      flex-direction: row; \n      flex-wrap: wrap;     \n      gap: 8px;\n      padding: 12px;\n      background-color: black;\n      box-sizing: border-box;\n      width: 100%;\n      border-bottom: 2px solid #3b82f6;\n      max-height: calc(100vh - 56px);\n      overflow-y: auto;\n    }\n\n    &.nav-collapsed {\n      .nav-items-wrapper {\n        display: none !important; \n      }\n    }\n\n    .nav-section-node {\n      flex: 1 1 calc(50% - 4px); \n      min-width: 130px;\n      position: relative;\n    }\n\n    .linkRoot {\n      flex-direction: column; \n      justify-content: center;\n      text-align: center;\n      background-color: rgba(255, 255, 255, 0.05);\n      border-radius: 8px;\n      padding: 12px 6px;\n      gap: 6px;\n      font-size: 18px; \n\n      svg {\n        margin-right: 0;\n      }\n    }\n\n    // Dropdown layouts popping down from horizontal tiles\n    .subLinks {\n      position: absolute;\n      top: 100%;\n      left: 0;\n      width: 100%;\n      z-index: 1010;\n      border-radius: 6px;\n      box-shadow: 0 8px 24px rgba(0, 0, 0, 0.5);\n      padding-left: 0;\n      margin-top: 4px;\n      background-color: #0c0c0c;\n      border: 1px solid rgba(255, 255, 255, 0.1);\n    }\n\n    .subLink {\n      justify-content: center;\n      padding: 12px;\n      font-size: 14px; \n      border-bottom: 1px solid rgba(255, 255, 255, 0.05);\n\n      .linkSpan::before {\n        display: none; \n      }\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
